import client from './rates-client';

export const ratesApi = () => client().get('/other');
